import { __decorate } from "tslib";
import { flatten } from '@d-fischer/shared-utils';
import { DataObject, rawDataSymbol, rtfm } from '@twurple/common';
/**
 * A list of chatters in a Twitch chat.
 */
let ChattersList = class ChattersList extends DataObject {
    /**
     * A list of user names of all chatters in the chat.
     */
    get allChatters() {
        return flatten(Object.values(this[rawDataSymbol].chatters));
    }
    /**
     * A map of user names of all chatters in the chat, mapped to their status in the channel.
     */
    get allChattersWithStatus() {
        return new Map(flatten(Object.entries(this[rawDataSymbol].chatters).map(([status, names]) => names.map(name => [name, status]))));
    }
};
ChattersList = __decorate([
    rtfm('api', 'ChattersList')
], ChattersList);
export { ChattersList };
